import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import EmptyCart from "../../empty_cart.svg";

const Cart = ({ cartItems, onRemoveFromCart, onUpdateQuantity }) => {
  const subtotal = cartItems.reduce((total, item) => {
    const price = item.salePrice ?? item.originalPrice;
    return total + price * item.quantity;
  }, 0);
  const tax = Number((subtotal * 0.075).toFixed(2));
  const orderTotal = subtotal + tax;

  return (
    <main id="books__main">
      <section className="container">
        <div className="row">
          <h1 className="cart__title">Your Cart</h1>
          {cartItems.length === 0 ? (
            <div className="cart__empty">
              <img src={EmptyCart} alt="" className="cart__empty--img" />
              <p>Your cart is empty.</p>
              <a href="/books" className="btn">
                Browse Books
              </a>
            </div>
          ) : (
            <>
              <div className="cart__header">
                <span>Book</span>
                <span>Quantity</span>
                <span>Total</span>
              </div>
              {cartItems.map((item) => {
                const price = item.salePrice ?? item.originalPrice;
                return (
                  <div className="cart__item" key={item.id}>
                    <div className="cart__book">
                      <img
                        src={item.url}
                        alt={`${item.title} cover`}
                        className="cart__book--img"
                      />
                      <div className="cart__book--info">
                        <h2 className="cart__book--title">{item.title}</h2>
                        <p className="cart__book--price">
                          ${Number(price).toFixed(2)} each
                        </p>
                        <button
                          className="cart__book--remove"
                          onClick={() => onRemoveFromCart(item.id)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                    <div className="cart__quantity">
                      <button
                        type="button"
                        className="cart__quantity--button"
                        aria-label={`Decrease ${item.title} quantity`}
                        onClick={() => onUpdateQuantity(item.id, -1)}
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                      <span aria-live="polite">{item.quantity}</span>
                      <button
                        type="button"
                        className="cart__quantity--button"
                        aria-label={`Increase ${item.title} quantity`}
                        onClick={() => onUpdateQuantity(item.id, 1)}
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>
                    <div className="cart__total">
                      ${(price * item.quantity).toFixed(2)}
                    </div>
                  </div>
                );
              })}
              <div className="total">
                <div className="total__item total__sub-total">
                  <span>Subtotal</span>
                  <span className="total__price">${subtotal.toFixed(2)}</span>
                </div>
                <div className="total__item">
                  <span>Tax (7.5%)</span>
                  <span className="total__price">${tax.toFixed(2)}</span>
                </div>
                <div className="total__item total__grand-total">
                  <span>Total</span>
                  <span className="total__price">${orderTotal.toFixed(2)}</span>
                </div>
                <div className="total__actions">
                  <button type="button" className="btn btn__checkout">
                    Checkout
                  </button>
                  <a href="/books" className="btn">
                    Continue Shopping
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      </section>
    </main>
  );
};

export default Cart;
